import { render, staticRenderFns } from "./InfoAccordion.vue?vue&type=template&id=0dbca440&scoped=true&"
import script from "./InfoAccordion.vue?vue&type=script&lang=js&"
export * from "./InfoAccordion.vue?vue&type=script&lang=js&"
import style0 from "./InfoAccordion.vue?vue&type=style&index=0&id=0dbca440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbca440",
  null
  
)

export default component.exports